import { createReducer, on } from '@ngrx/store'
import { appProgressbarClose, appProgressbarStart, appProgressbarUpdate } from '../../models/interfaces/app-progressbar-state.interface'
import * as ProjectActions from './project.actions'
import { initialProjectState } from './project.state'

export const projectReducer = createReducer(
   initialProjectState,

   on(ProjectActions.exportProject, (state) => ({ ...state, exportProgress: appProgressbarStart() })),
   on(ProjectActions.exportProjectSuccess, (state, { response }) => ({
      ...state,
      exportProgress: appProgressbarUpdate(state.exportProgress || appProgressbarStart(), response)
   })),
   on(ProjectActions.exportProjectFailed, (state) => ({ ...state, exportProgress: appProgressbarClose('error') })),
   on(ProjectActions.closeExportProgress, (state) => ({ ...state, exportProgress: undefined })),

   on(ProjectActions.loadPartnerList, (state) => {
      return { ...state, isLoadingPartnerList: true, partnerList: undefined }
   }),
   on(ProjectActions.loadPartnerListSuccess, (state, action) => {
      return {
         ...state,
         isLoadingPartnerList: undefined,
         partnerList: action.response
      }
   }),
   on(ProjectActions.loadPartnerListFailed, (state) => {
      return { ...state, isLoadingPartnerList: undefined }
   }),
   on(ProjectActions.loadPartner, (state) => {
      return { ...state, partnerActive: undefined, isLoadingPartnerActive: true }
   }),
   on(ProjectActions.loadPartnerSuccess, (state, action) => {
      return { ...state, partnerActive: action.response, isLoadingPartnerActive: undefined }
   }),
   on(ProjectActions.loadPartnerFailed, ProjectActions.clearPartnerActive, (state) => {
      return { ...state, partnerActive: undefined, isLoadingPartnerActive: undefined }
   }),
   on(ProjectActions.updatePartnerOrderSuccess, (state, action) => {
      return { ...state, partnerList: action.response }
   }),

   on(ProjectActions.loadPerson, (state) => {
      return { ...state, personActive: undefined, isLoadingPersonActive: true }
   }),
   on(ProjectActions.loadPersonSuccess, (state, action) => {
      return { ...state, personActive: action.response, isLoadingPersonActive: undefined }
   }),
   on(ProjectActions.loadPersonFailed, ProjectActions.clearPersonActive, (state) => {
      return { ...state, personActive: undefined, isLoadingPersonActive: undefined }
   }),
   on(ProjectActions.searchPersonsByEmail, (state) => {
      return { ...state, isLoadingPersonEmailSearch: true }
   }),
   on(ProjectActions.searchPersonsByEmailSuccess, (state, action) => {
      return { ...state, personEmailSearchResults: action.response, isLoadingPersonEmailSearch: undefined }
   }),
   on(ProjectActions.searchPersonsByEmailFailed, ProjectActions.clearPersonEmailSearch, (state) => {
      return { ...state, personEmailSearchResults: undefined, isLoadingPersonEmailSearch: undefined }
   }),
   on(ProjectActions.loadProjectTodo, (state) => {
      return {
         ...state,
         projectTodoData: undefined,
         isLoadingProjectTodo: true
      }
   }),
   on(ProjectActions.loadProjectTodoSuccess, (state, action) => {
      return {
         ...state,
         projectTodoData: action.response,
         isLoadingProjectTodo: undefined
      }
   }),
   on(ProjectActions.loadProjectTodoFailed, (state) => {
      return {
         ...state,
         projectTodoData: undefined,
         isLoadingProjectTodo: undefined
      }
   }),
   on(ProjectActions.clearProjectTodo, (state) => {
      return { ...state, projectTodoData: undefined, isLoadingProjectTodo: undefined }
   }),
   on(ProjectActions.loadTodo, (state) => {
      return { ...state, todoActive: undefined, isLoadingTodoActive: true }
   }),
   on(ProjectActions.loadTodoSuccess, (state, action) => {
      return { ...state, todoActive: action.response, isLoadingTodoActive: undefined }
   }),
   on(ProjectActions.loadTodoFailed, (state) => {
      return { ...state, todoActive: undefined, isLoadingTodoActive: undefined }
   }),
   on(ProjectActions.clearTodoActive, (state) => {
      return { ...state, todoActive: undefined, isLoadingTodoActive: undefined }
   }),
   on(ProjectActions.loadReportingPeriods, (state) => {
      return { ...state, reportingPeriods: undefined, isLoadingReportingPeriods: true }
   }),
   on(ProjectActions.loadReportingPeriodsSuccess, (state, action) => {
      return { ...state, reportingPeriods: action.response, isLoadingReportingPeriods: undefined }
   }),
   on(ProjectActions.loadReportingPeriodsFailed, (state) => {
      return { ...state, reportingPeriods: undefined, isLoadingReportingPeriods: undefined }
   }),
   on(ProjectActions.addReportingPeriod, ProjectActions.deleteReportingPeriod, (state) => {
      return { ...state, isLoadingReportingPeriods: true }
   }),
   on(
      ProjectActions.addReportingPeriodSuccess,
      ProjectActions.addReportingPeriodFailed,
      ProjectActions.deleteReportingPeriodSuccess,
      ProjectActions.deleteReportingPeriodFailed,
      (state) => {
         return { ...state, isLoadingReportingPeriods: undefined }
      }
   ),
   on(ProjectActions.loadLogo, (state) => {
      return { ...state, logo: undefined, isLoadingLogo: true }
   }),
   on(ProjectActions.loadLogoSuccess, (state, action) => {
      return { ...state, logo: action.file, isLoadingLogo: undefined }
   }),
   on(ProjectActions.loadLogoFailed, (state) => {
      return { ...state, logo: undefined, isLoadingLogo: undefined }
   }),
   on(ProjectActions.uploadLogo, ProjectActions.deleteLogo, (state) => {
      return { ...state, isLoadingLogo: true }
   }),
   on(ProjectActions.uploadLogoSuccess, ProjectActions.uploadLogoFailed, ProjectActions.deleteLogoSuccess, ProjectActions.deleteLogoFailed, (state) => {
      return { ...state, isLoadingLogo: undefined }
   }),
   on(ProjectActions.loadDocuments, (state) => {
      return { ...state, documents: undefined, isLoadingDocuments: true }
   }),
   on(ProjectActions.loadDocumentsSuccess, (state, action) => {
      return { ...state, documents: action.response, isLoadingDocuments: undefined }
   }),
   on(ProjectActions.loadDocumentsFailed, (state) => {
      return { ...state, documents: undefined, isLoadingDocuments: undefined }
   }),
   on(ProjectActions.addDocument, ProjectActions.updateDocument, ProjectActions.deleteDocument, (state) => {
      return { ...state, isLoadingDocuments: true }
   }),
   on(
      ProjectActions.addDocumentSuccess,
      ProjectActions.addDocumentFailed,
      ProjectActions.updateDocumentSuccess,
      ProjectActions.updateDocumentFailed,
      ProjectActions.deleteDocumentSuccess,
      ProjectActions.deleteDocumentFailed,
      (state) => {
         return { ...state, isLoadingDocuments: undefined }
      }
   )
)
